import LivingLabCreator from "../../componants/livinglab/LivingLabCreator";

function AddLivingLab(){
    return(
        <LivingLabCreator>

        </LivingLabCreator>
    )
}

export default AddLivingLab;
